import { RuleIcon, RulePreview } from '@carboncopyco/editor-ui';
import { VariableIcon } from '@carboncopyco/icons';
import type { IImageReplaceWithVariableRule } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { useContext } from 'react';
import { FindAndReplaceManagerContext } from '../FindAndReplaceManagerContext';
import { Layout, type LayoutProps } from './Layout';

export type ReplaceImageWithVariablePreviewProps = Pick<LayoutProps, 'layout'> &
  Pick<
    IImageReplaceWithVariableRule,
    'sourceFileServiceLink' | 'sourceFileMetadata' | 'destinationVariableId'
  >;

export const ReplaceImageWithVariablePreview = ({
  sourceFileServiceLink,
  sourceFileMetadata,
  destinationVariableId,
  layout,
}: ReplaceImageWithVariablePreviewProps) => {
  const { variables } = useContext(FindAndReplaceManagerContext);
  const variable = variables.find(
    ({ variableId }) => variableId === destinationVariableId
  );
  return (
    <RulePreview>
      <div className="shrink-0">
        <RuleIcon backgroundImageUrl={sourceFileServiceLink} />
      </div>
      <Layout layout={layout}>
        <Text label={sourceFileMetadata.name} />
        <RulePreview.Arrow />
        <div className="flex flex-row items-center gap-2.5 truncate max-w-[200px]">
          <div className="shrink-0">
            <RuleIcon>
              <VariableIcon />
            </RuleIcon>
          </div>
          <Text label={variable?.name} />
        </div>
      </Layout>
    </RulePreview>
  );
};

const Text = ({ label }: { label: string }) => (
  <RulePreview.Tooltip title={label}>
    <span className="truncate">
      <TextBase
        label={label}
        color="text-ds-natural-600"
        ellipsis
      />
    </span>
  </RulePreview.Tooltip>
);
